///<amd-module name="typeahead/core/logging/ScanabilityMetric" />

import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";

export class ScanabilityMetric extends TypeaheadMetric {

    public latency: number;
    public selectionMethod: string;

    constructor(lob: string, elementId: string, suggestionShownTimestamp: number, suggestionSelectedTimestamp: number,
                selectionMethod: string, activeESSTests: string) {
        super(lob, elementId, "scan", activeESSTests);
        this.latency = suggestionSelectedTimestamp - suggestionShownTimestamp;
        this.selectionMethod = selectionMethod;
    }
}
